import { Outlet, useLocation } from "react-router-dom";
import { TitleBar } from "@shopify/app-bridge-react";

export function MainLayout() {
  const location = useLocation();

  // Determine the title based on the current route
  // This helps in updating the Shopify embedded title bar
  const getPageTitle = () => {
    switch (location.pathname) {
      case "/":
        return "Dashboard";
      case "/forms":
        return "Forms";
      default:
        return "CodWay Admin";
    }
  };

  return (
    <>
      <TitleBar title={getPageTitle()} />
      <Outlet />
    </>
  );
}
